import USAImage1 from "../assets/news/us news.jpg";
import USAImage2 from "../assets/news/us news 2.jpg";
import USAImage3 from "../assets/news/us news 3.jpg";
import USAImage4 from "../assets/news/us news 4.avif";
import UKImage1 from "../assets/news/uk1.png";
import UKImage2 from "../assets/news/uk2.jpeg";
import UKImage3 from "../assets/news/uk3.webp";
import UKImage4 from "../assets/news/uk4.jpeg";
import CanadaImage1 from "../assets/news/canada1.jpeg";
import CanadaImage2 from "../assets/news/canada2.jpg";
import CanadaImage3 from "../assets/news/canada3.jpg";
import CanadaImage4 from "../assets/news/canada4.webp";

export const newsData = [
  // USA News
  {
    title: "New Scholarships for International Students in the USA",
    subtext:
      "Several top universities in the USA are offering scholarships for international students for the 2025 academic year.",
    image: USAImage1,
    date: "2024-12-15",
    country: "USA",
    link: "/news/usa/1",
  },
  {
    title: "US Immigration Updates: What International Students Need to Know",
    subtext:
      "Stay updated with the latest changes to US immigration policies affecting international students.",
    image: USAImage2,
    date: "2024-12-10",
    country: "USA",
    link: "/news/usa/2",
  },
  {
    title: "Top US Universities Offering Financial Aid for 2025",
    subtext:
      "Explore the universities in the USA offering financial aid and grants for international students.",
    image: USAImage3,
    date: "2024-11-20",
    country: "USA",
    link: "/news/usa/3",
  },
  {
    title: "Study in the USA: Tips for International Students",
    subtext:
      "A guide for international students planning to pursue higher education in the USA.",
    image: USAImage4,
    date: "2024-10-30",
    country: "USA",
    link: "/news/usa/4",
  },

  // UK News
  {
    title: "New Visa Rules for International Students in the UK",
    subtext:
      "The UK government has introduced new visa regulations to streamline the student visa application process.",
    image: UKImage1,
    date: "2024-12-12",
    country: "UK",
    link: "/news/uk/1",
  },
  {
    title: "Top Universities in the UK Offering Postgraduate Programs for 2025",
    subtext:
      "Explore the best universities in the UK for postgraduate courses in 2025, offering a range of scholarships.",
    image: UKImage2,
    date: "2024-11-20",
    country: "UK",
    link: "/news/uk/2",
  },
  {
    title: "UK Offers New Work Visa for International Graduates",
    subtext:
      "The UK introduces a work visa to allow international graduates to gain professional experience.",
    image: UKImage3,
    date: "2024-11-10",
    country: "UK",
    link: "/news/uk/3",
  },
  {
    title: "UK Universities Launch New Online Degree Programs",
    subtext:
      "UK universities are offering online degree programs to cater to international students.",
    image: UKImage4,
    date: "2024-10-25",
    country: "UK",
    link: "/news/uk/4",
  },

  // Canada News
  {
    title: "Canada’s New Express Entry Draw for International Students",
    subtext:
      "Canada is offering a fast-track immigration process for international students through its Express Entry system.",
    image: CanadaImage1,
    date: "2024-11-25",
    country: "Canada",
    link: "/news/canada/1",
  },
  {
    title: "Work and Study Opportunities for International Students in Canada",
    subtext:
      "How international students can balance studying and working part-time in Canada while earning extra income.",
    image: CanadaImage2,
    date: "2024-10-30",
    country: "Canada",
    link: "/news/canada/2",
  },
  {
    title: "Canada Increases Funding for International Scholarships",
    subtext:
      "Canada announces additional funding for scholarships available to international students.",
    image: CanadaImage3,
    date: "2024-10-20",
    country: "Canada",
    link: "/news/canada/3",
  },
  {
    title: "Top Universities in Canada to Apply for in 2025",
    subtext:
      "Learn about the top universities in Canada for the 2025 academic year.",
    image: CanadaImage4,
    date: "2024-09-30",
    country: "Canada",
    link: "/news/canada/4",
  },

  // Australia News
  {
    title:
      "Australia Announces New Post-Study Work Visa for International Graduates",
    subtext:
      "The Australian government introduces a new post-study work visa that allows international graduates to stay longer after completing their studies.",
    image: USAImage1,
    date: "2024-12-05",
    country: "Australia",
    link: "/news/australia/1",
  },
  {
    title: "Top 5 Cities to Study in Australia in 2025",
    subtext:
      "Discover the best cities in Australia to study in, based on factors like living costs, universities, and lifestyle.",
    image: USAImage2,
    date: "2024-11-15",
    country: "Australia",
    link: "/news/australia/2",
  },
  {
    title: "Australian Scholarships for International Students",
    subtext:
      "Learn about the scholarships offered by Australian universities for international students in 2025.",
    image: USAImage3,
    date: "2024-10-25",
    country: "Australia",
    link: "/news/australia/3",
  },
  {
    title: "Visa Application Guide for Australia 2025",
    subtext:
      "A step-by-step guide for applying for student visas to study in Australia.",
    image: USAImage4,
    date: "2024-10-10",
    country: "Australia",
    link: "/news/australia/4",
  },

  // Germany News
  {
    title: "Germany Offers Scholarships for International Students for 2025",
    subtext:
      "Several universities in Germany are offering scholarships to international students for the upcoming academic year.",
    image: UKImage1,
    date: "2024-12-10",
    country: "Germany",
    link: "/news/germany/1",
  },
  {
    title: "Germany’s New Student Visa Regulations for 2025",
    subtext:
      "Everything you need to know about the new student visa regulations in Germany for 2025.",
    image: UKImage2,
    date: "2024-12-01",
    country: "Germany",
    link: "/news/germany/2",
  },
  {
    title: "Top German Universities Open Applications for 2025",
    subtext:
      "Find out which German universities are now accepting applications for the 2025 academic year.",
    image: UKImage3,
    date: "2024-11-20",
    country: "Germany",
    link: "/news/germany/3",
  },
  {
    title: "Germany Announces New Research Grants for International Students",
    subtext:
      "International students pursuing research in Germany can now apply for new grants available for 2025.",
    image: UKImage4,
    date: "2024-11-05",
    country: "Germany",
    link: "/news/germany/4",
  },

  // New Zealand News
  {
    title: "New Zealand Offers New Scholarships for International Students",
    subtext:
      "A new round of scholarships for international students is now available at universities in New Zealand.",
    image: CanadaImage1,
    date: "2024-12-10",
    country: "New Zealand",
    link: "/news/newzealand/1",
  },
  {
    title: "How to Apply for Student Visas in New Zealand for 2025",
    subtext:
      "A comprehensive guide on how to apply for student visas to study in New Zealand in 2025.",
    image: CanadaImage2,
    date: "2024-11-28",
    country: "New Zealand",
    link: "/news/newzealand/2",
  },
  {
    title: "Study and Work Opportunities for Students in New Zealand",
    subtext:
      "Explore how international students can study and work part-time in New Zealand while managing their finances.",
    image: CanadaImage3,
    date: "2024-11-10",
    country: "New Zealand",
    link: "/news/newzealand/3",
  },
  {
    title: "Top New Zealand Universities for International Students",
    subtext:
      "Discover the best universities in New Zealand for international students to apply to for 2025.",
    image: CanadaImage4,
    date: "2024-10-30",
    country: "New Zealand",
    link: "/news/newzealand/4",
  },

  // European Union News
  {
    title: "Study Abroad Opportunities in European Universities",
    subtext:
      "Explore study programs in leading European universities, including scholarships and application deadlines for 2025.",
    image: USAImage1,
    date: "2024-11-05",
    country: "European Union",
    link: "/news/eu/1",
  },
  {
    title: "EU Launches New Funding Program for International Students",
    subtext:
      "The European Union has launched a new funding program for international students looking to study in Europe.",
    image: USAImage2,
    date: "2024-10-30",
    country: "European Union",
    link: "/news/eu/2",
  },
  {
    title: "Top European Cities for International Students in 2025",
    subtext:
      "A guide to the top cities in Europe for international students based on lifestyle, costs, and university rankings.",
    image: USAImage3,
    date: "2024-10-20",
    country: "European Union",
    link: "/news/eu/3",
  },
  {
    title: "Erasmus Program 2025: What’s New for Students?",
    subtext:
      "Learn about the latest updates to the Erasmus program and how it benefits international students in Europe.",
    image: USAImage4,
    date: "2024-09-30",
    country: "European Union",
    link: "/news/eu/4",
  },
];
